module.exports = __webpack_public_path__ + "img/caret-right-green-2.e7bf7592.svg";